<template>
  <div class="editor-budget-container">
    <ContentHeader :showBack="false" />
    <div class="content-container">
      <div class="perfect-budget-style">
        <div class="buttonStyle">
          <el-button
            type="danger"
            class="btn-red"
            size="medium"
            @click="handleBudget()"
            >维护预算池</el-button
          >
        </div>
        <!-- <div v-if="tableHeadConfig.length"> -->
        <div>
          <el-table
            :data="clientInfoList"
            :key="tableHeadConfig.length"
            border
            max-height="500"
            v-loading="listLoading"
            row-key="regionCode"
            :header-cell-style="{
              background: '#F5F7FA',
              color: '#606266',
              textAlign: 'center',
            }"
            :row-style="{ height: '57px' }"
            header-row-class-name="table-head-row"
            default-expand-all
            :cell-style="cellStyle"
            :tree-props="{
              children: 'areaBudgetInfos',
              hasChildren: 'hasChildren',
            }"
          >
            <el-table-column
              label="配置到Area"
              width="100"
              fixed="left"
              align="right"
            >
              <template slot-scope="scope">
                <el-switch
                  v-if="scope.row.budgetLevel === 10"
                  v-model="scope.row.isOpen"
                  :disabled="scope.row.isDisabled"
                  @change="handleTableRowSwitch(scope.row, scope.$index)"
                  active-color="#13ce66"
                >
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column
              label="Region/Area"
              min-width="130"
              prop="regionName"
              fixed="left"
              class-name="region-area-value"
              align="left"
            >
            </el-table-column>
            <el-table-column label="可用预算" align="center" width="800">
              <el-table-column
                v-for="(head, index) in tableHeadConfig"
                :key="index"
                :label="head.typeName"
                :prop="head.typeName"
                min-width="150"
                align="center"
              >
              <template slot="header">
                <div>{{ `${head.typeName} ` }}</div>
                <div style="color:#C8102D;font-weight:400;font-size:12px">{{`( ${head.trCodeName} )`}}</div>
              </template>
                <template slot-scope="{ row }">
                  <!--  true  || true-->
                  <div v-if="row.edit">
                    <el-input
                      v-model="row[head.typeName + '-' + 'available']"
                      :disabled="!row.edit || row.orDisabled"
                      @input="
                        getInputVal($event, {
                          row,
                          key: head.typeName + '-' + 'available',
                          index: index,
                        })
                      "
                    ></el-input>
                  </div>
                  <!-- 文本的有千分符  要转回去 -->
                  <div v-else>
                    {{
                      row[head.typeName + "-" + "available"]
                        | formatNumber("number")
                    }}
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="合计"
              class-name="merge-cell2"
              align="center"
              fixed="right"
              prop="availableAmount"
              width="120"
            >
              <template slot-scope="{ row }">
                {{ row.availableAmount | formatNumber("number") }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="btnStyle">
          <el-button class="btn-reset" @click="cancel">取消</el-button>
          <el-button class="btn-red" @click="editorConfirm">提交</el-button>
        </div>
        <!-- </div> -->
        <!-- <div>暂且无预算池信息,请维护预算池</div> -->
      </div>
      <!-- 维护预算池 -->
      <MaintBudget ref="maintenance-budget-pool" @refresh="refresh" />
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header.vue'
import MaintBudget from './components/maintenance-budget-pool'
import budgetApi from '@/api/budget'
import { Message } from 'element-ui'
// 千分符
const filters = {
  formatNumber (number, type) {
    if (!number && number !== 0) return
    if (type === 'number') {
      return number.toLocaleString()
    } else if (type === 'money') {
      return '￥' + number.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    }
  }
}

export default {
  name: 'editor-budget',
  components: {
    ContentHeader,
    MaintBudget
  },
  props: {},
  data () {
    return {
      swiOpen: false,
      swDisabled: false,
      isInfos: 0,
      SwiRowregCode: '',
      // InputVal: '',
      listLoading: false,
      // 预算池名称数据
      tableHeadConfig: [],
      // table数据
      clientInfoList: [],
      queryMsg: {
        orgCode: ''

      },
      orDisabled: false,
      sum: []
    }
  },
  computed: {
    // // 过滤数据
    // getNum (val) {
    //   return 1
    // }

  },
  filters,
  created () {
    // 获取table数据
    this.handleSearch()
    this.getBudget()
    this.queryMsg.orgCode = this.$route.query.buCode
  },
  mounted () {
  },
  methods: {
    cellStyle (val) {
      return 'padding:0px; background-color: #fff;'// 调整单元格的高度
    },
    // 实时计算合计
    getInputVal (e, args) {
      // oninput="value=value.replace(/^\.+|[^\d]/g,'')"
      let { row, key } = args
      // console.log(e, args)
      // row[key] = e.replace(/^\.+|[^\d]/g, '')
      row[key] = e.replace(/[^\.\d]/g, '')
      if (row[key]) {
        row[key] = row[key].match(/^\d+(?:\.\d{0,2})?/)[0]
      }
      this.tableHeadConfig.forEach((head, headIndex) => {
        let val = row[head.typeName + '-' + 'available'] || 0
        this.$set(this.sum, headIndex, val)
      })
      let sumNum = 0
      this.sum.forEach(item => {
        sumNum += Number(item)
      })
      row.availableAmount = sumNum
    },
    // 给label用的（转千分符）
    getFirstLabel (property) {
      // console.log(property, 'property')
      const value = this.clientInfoList[0][property]
      // console.log('--value---', value)
      return filters.formatNumber(value, 'number')
    },
    changeNum (e, args) {
      console.log(e, args, 'val')
    },
    // 更新
    refresh (val) {
      this.getBudget()
      this.handleSearch()
    },
    // 获取预算池名称
    getBudget () {
      let params = {
        buCode: this.$route.query.buCode
      }
      budgetApi.getTableHeadConfig(params).then(res => {
        if (res.data.resultCode === '0') {
          this.tableHeadConfig = res.data.resultData.budgetTypeList// 表头
        }
      })
    },
    // 获取table数据
    handleSearch () {
      this.listLoading = true
      budgetApi.getPerfectThemeList(this.$route.query).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          let resData = res.data.resultData.budgetInfoList
          this.clientInfoList = this.deepCLone(resData)
          console.log(this.clientInfoList)
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    // 获取table数据--处理数据
    deepCLone (arr) {
      let tempArr = []
      arr.forEach(parent => {
        let tempObj = {
          regionCode: parent.regionCode,
          regionName: parent.regionName.split('|')[0],
          budgetLevel: parent.budgetLevel,
          budgetInfos: parent.budgetInfos || [], // switch 禁用？
          areaBudgetInfos: parent.areaBudgetInfos || [], // switch 开还是关？
          availableAmount: parent.availableAmount,
          freezeAmount: parent.freezeAmount,
          usedAmount: parent.usedAmount,
          totalAmount: parent.totalAmount,
          edit: parent.edit, // true---input框数据可以编辑  false---input框禁用(打开的ragion下的area和没打开的ragion)
          isOpen: Boolean(parent.areaBudgetInfos.length > 0 ? 1 : 0), // 转化 ---开or关
          isDisabled: Boolean(parent.budgetInfos.length > 0 ? 1 : 0)
          // isAreaDisabled: Boolean((parent.areaBudgetInfos.length && parent.areaBudgetInfos.budgetLevel === 20) ? 0 : 1)
        }
        tempObj.budgetInfos.forEach(item => {
          const mapObj = {
            typeName: item.typeName,
            available: item.availableAmount,
            freeze: item.freezeAmount,
            used: item.usedAmount,
            total: item.totalAmount
          }
          // tempObj[item.typeName + '-available'] = filters.formatNumber(mapObj.available, 'number')
          tempObj[item.typeName + '-available'] = mapObj.available
          tempObj[item.typeName + '-freeze'] = mapObj.freeze
          tempObj[item.typeName + '-used'] = mapObj.used
          tempObj[item.typeName + '-total'] = mapObj.total
        })
        if (tempObj.budgetLevel === 10) {
          tempObj.areaBudgetInfos = this.deepCLone(parent.areaBudgetInfos)
        }
        tempArr.push(tempObj)
      })
      return tempArr
    },
    // 维护预算池
    handleBudget () {
      this.$refs['maintenance-budget-pool'].show()
      this.$refs['maintenance-budget-pool'].editorBudget(this.queryMsg)
    },
    // 取消
    cancel () {
      this.$router.push({ path: '/trade/perfect-budget', query: { buCode: this.queryMsg.orgCode } })
    },
    // 去除千分位,参数num必须为数字、逗号、小数点组成的字符串
    // delcommafy (num) {
    //   if (!num) {
    //     return null
    //   }
    //   return num.replace(',', '')
    // },
    delcommafy (num) {
      if (num === undefined || num == null) {
        num = String(0)
      }
      num = num.toString()
      num = num.replace(/[ ]/g, '') // 去除空格
      num = num.replace(/,/gi, '')
      return String(num)
    },
    // 提交
    editorConfirm () {
      let submitArr = []
      submitArr = this.deepParseData(this.clientInfoList)
      this.sum = submitArr
      let isContinue = true
      let isHasVal = false
      this.clientInfoList.some(child => {
        this.tableHeadConfig.some(head => { // 预算池
          if (child[head.typeName + '-available'] && !child.isDisabled) {
            isHasVal = true
            isContinue = false
            return true
          }
        })
        if (!isContinue) {
          return true
        }
      })
      this.clientInfoList.forEach(parent => {
        if (!parent.isDisabled && parent.isOpen) {
          const childArr = parent.areaBudgetInfos
          childArr.some(child => {
            this.tableHeadConfig.some(head => {
              if (child[head.typeName + '-available']) {
                isHasVal = true
                isContinue = false
                return true
              }
            })
            if (!isContinue) {
              return true
            }
          })
        }
      })

      if (isHasVal) {
        this.$confirm('请确认预算配置到Area的设置是否正确，提交后将不可再修改！', '提示', {
          cancelButtonText: '去确认',
          confirmButtonText: '已确认，提交',
          type: 'warning'
        }).then(() => {
          // 调接口
          this.listLoading = true
          budgetApi.editorConfirm(submitArr).then(res => {
            this.listLoading = false
            if (res.data.resultCode === '0') {
              this.$router.push({ path: '/trade/perfect-budget', query: { buCode: this.queryMsg.orgCode } })
            }
          }).catch(() => {
            this.listLoading = false
          })
        })
      } else {
        // 调接口
        this.listLoading = true
        budgetApi.editorConfirm(submitArr).then(res => {
          this.listLoading = false
          if (res.data.resultCode === '0') {
            this.$router.push({ path: '/trade/perfect-budget', query: { buCode: this.queryMsg.orgCode } })
          }
        }).catch(() => {
          this.listLoading = false
        })
      }
    },
    // 提交的入参处理
    deepParseData (arr) {
      let tempArr = []
      arr.forEach(parent => {
        let tmpObj = {
          // regionCode: parent.isOpen && parent.regionCode,
          regionCode: parent.regionCode,
          budgetLevel: parent.budgetLevel,
          edit: parent.edit,
          // totalAmount: parent.totalAmount,
          budgetInfos: [],
          areaBudgetInfos: []
        }
        tmpObj.budgetInfos = this.tableHeadConfig.map(item1 => {
          let bugetTmp = {
            typeId: item1.typeId,
            typeName: item1.typeName,
            availableAmount: parent[item1.typeName + '-available'] || ''
          }
          let newBugetTmp = parent.budgetInfos.find(item2 => item2.typeName === item1.typeName)
          return { ...newBugetTmp, ...bugetTmp }
        })
        if (!parent.budgetInfos.length) {
          tmpObj.budgetInfos = this.tableHeadConfig.map(item => {
            return {
              typeId: item.typeId,
              typeName: item.typeName,
              availableAmount: parent[item.typeName + '-available'] || ''
            }
          })
          this.sum = tmpObj.budgetInfos
          console.log(this.sum, 'this.sum@@')
        }
        if (parent.areaBudgetInfos && parent.areaBudgetInfos.length) {
          tmpObj.areaBudgetInfos = this.deepParseData(parent.areaBudgetInfos)
        }
        tempArr.push(tmpObj)
      })
      return tempArr
    },
    // 开关调用子数据
    handleTableRowSwitch (row) {
      console.log(row)
      row.edit = false
      this.swiOpen = row.isOpen
      this.SwiRowregCode = row.regionCode
      this.swDisabled = row.isDisabled
      if (row.isOpen) {
        row.availableAmount = 0
      }
      if (row.isOpen) {
        let params = {
          regionCode: row.regionCode

        }
        budgetApi.getAreaListByRegion(params).then(data => {
          if (data.data.resultCode === '0') {
            if (data.data.resultData.orgList.length > 0) {
              row.areaBudgetInfos = data.data.resultData.orgList
              // 清空
              this.tableHeadConfig.forEach(item => {
                this.$set(row, `${item.typeName}-available`, '')
              })
            } else {
              Message.warning({
                message: '该Region没有Area数据',
                duration: 2000,
                onClose: () => {
                  row.isOpen = false
                  row.edit = true
                }
              })
            }
          }
        }).catch(() => { })

        // 禁用这一行region
        // row.orDisabled = !row.isOpen
      } else {
        row.edit = true
        row.areaBudgetInfos = []
      }
    }
  }
}
</script>

<style lang="scss">
.el-table__row.expanded {
  .el-table__expand-icon {
    visibility: hidden;
  }
}
.editor-budget-container {
  .perfect-budget-style {
    width: 1200px;
    margin: 0 auto;
  }

  .buttonStyle {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
  }
  // .editor-budget-table {
  //   .el-table__body-wrapper,
  //   .el-table__fixed-body-wrapper {
  //     .el-table__row:nth-child(1) {
  //       background-color: red;

  //       .el-table__cell {
  //         display: none;
  //       }
  //     }
  //   }

  .el-table__row--level-1 {
    .region-area-value {
      text-align: right;
    }
  }
  // }

  .btnStyle {
    margin-top: 20px;
    display: flex;
    justify-content: space-evenly;
  }
}
.el-input__inner {
  text-align: center;
}
::v-deep .el-table__fixed-right-patch {
  background: rgb(90, 91, 92);
}
</style>
